import { ActionType, createAction } from "typesafe-actions";
import { NoteReply, TransactionNote } from "../../types/note/Note";
import { RequestState } from "../../constants/request-state";

const requestNotes = createAction('entities/transactionNotes/REQUEST',
    resolve => (transactionReferenceName: string) => resolve({ transactionReferenceName })
);
const requestResult = createAction('entities/transactionNotes/REQUEST-RESULT',
    resolve => (transactionReferenceName: string, requestState: RequestState, notes: TransactionNote[]) =>
        resolve({ transactionReferenceName, requestState, notes })
);
const noteChanged = createAction('entities/transactionNotes/NOTE_CHANGED',
    resolve => (note: TransactionNote) => resolve({ note })
);
const noteReplyChanged = createAction('entities/transactionNotes/NOTE_REPLY_CHANGED',
    resolve => (transactionReferenceName: string, reply: NoteReply) => resolve({ transactionReferenceName, reply })
);
const noteDeleted = createAction('entities/transactionNotes/NOTE_DELETED',
    resolve => (transactionReferenceName: string, noteId: number) => resolve({ transactionReferenceName, noteId })
);
const noteReplyDeleted = createAction('entities/transactionNotes/NOTE_REPLY_DELETED',
    resolve => (transactionReferenceName: string, noteId: number, replyId: number) => resolve({ transactionReferenceName, noteId, replyId })
);
const myNotesDeleted = createAction('entities/transactionNotes/MY_NOTES_DELETED',
    resolve => (transactionReferenceName: string) => resolve({ transactionReferenceName })
);
const reset = createAction('entities/transactionNotes/RESET');

export const transactionNoteActions = {
    requestNotes,
    requestResult,
    noteChanged,
    noteReplyChanged,
    noteDeleted,
    noteReplyDeleted,
    myNotesDeleted,
    reset
}

export type TTransactionNoteActionType = ActionType<
    (typeof transactionNoteActions)[keyof typeof transactionNoteActions]
>;

